export default __webpack_public_path__ + "static/media/docker-blog.8655cefc.png";